import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Input,
    InputGroup,
    InputLeftElement,
    Textarea,
    useToast,
    VStack,
    Image,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsPerson } from 'react-icons/bs';
import { MdOutlineEmail } from 'react-icons/md';
import emailjs from 'emailjs-com';
import img from './assets/images/contactus.jpg';

export default function ContactUs() {
    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const { t } = useTranslation();
    const toast = useToast();

    const onSubmit = async () => {
        if (!nom || !email || !message) {
            toast({
                description: t("Veuillez remplir les champs!"),
                status: 'error',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right',
                variant: "left-accent"
            });
            return;
        }

        try {
            await emailjs.send(
                'radio_screen',
                'template_gs5b22v',
                {
                    name: nom,
                    email: email,
                    message: message
                },
                'xhzjpGbKeU8SDSIJf'
            );
            toast({
                title: t("Message envoyé avec succès"),
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
            setNom("");
            setEmail("");
            setMessage('');
        } catch (error) {
            toast({
                title: t("Erreur lors de l'envoi de l'email"),
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
        }
    };

    return (
        <Box maxW="1200px" py={20} mx="auto">
            <VStack spacing={{ base: 8, md: 12 }}>
                <Heading
                    fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
                    bgGradient="linear(to-r, cyan.600, blue.600)"
                    bgClip="text"
                    textAlign="center"
                >
                    {t("Contactez-nous")}
                </Heading>

                <Flex
                    w={{ base: "95%", sm: "85%", lg: "80%", xl: "75%" }}
                    bg="white"
                    borderRadius="2xl"
                    overflow="hidden"
                    boxShadow="2xl"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <Image
                        w={{ base: "100%", md: "40%" }}
                        h={{ base: "200px", md: "auto" }}
                        objectFit="cover"
                        src={img}
                        alt="Contact"
                    />
                    <VStack 
                        w={{ base: "100%", md: "60%" }} 
                        p={{ base: 6, md: 8 }} 
                        spacing={4}
                        align="stretch"
                    >
                        <FormControl isRequired>
                            <FormLabel>{t("Nom complet")}</FormLabel>
                            <InputGroup>
                                <InputLeftElement children={<BsPerson />} />
                                <Input
                                    onChange={(e) => setNom(e.target.value)}
                                    value={nom}
                                    type="text"
                                    name="name"
                                    placeholder={t("Votre nom complet")}
                                    borderRadius="lg"
                                    _focus={{ borderColor: 'cyan.500', boxShadow: '0 0 0 1px cyan.500' }}
                                />
                            </InputGroup>
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel>{t("E-mail")}</FormLabel>
                            <InputGroup>
                                <InputLeftElement children={<MdOutlineEmail />} />
                                <Input
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                    type="email"
                                    name="email"
                                    placeholder={t("Votre adresse e-mail")}
                                    borderRadius="lg"
                                    _focus={{ borderColor: 'cyan.500', boxShadow: '0 0 0 1px cyan.500' }}
                                />
                            </InputGroup>
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel>{t("Message")}</FormLabel>
                            <Textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                name="message"
                                placeholder={t("Votre message")}
                                rows={5}
                                resize="none"
                                borderRadius="lg"
                                _focus={{ borderColor: 'cyan.500', boxShadow: '0 0 0 1px cyan.500' }}
                            />
                        </FormControl>

                        <Button
                            bgGradient="linear(to-r, cyan.500, blue.500)"
                            color="white"
                            _hover={{ 
                                bgGradient: "linear(to-r, cyan.600, blue.600)",
                                transform: 'translateY(-2px)',
                                boxShadow: 'lg'
                            }}
                            onClick={onSubmit}
                            isFullWidth
                            size="lg"
                            borderRadius="lg"
                            transition="all 0.3s"
                            mt={2}
                        >
                            {t("Envoyer le message")}
                        </Button>
                    </VStack>
                </Flex>
            </VStack>
        </Box>
    );
}